import React, { useState, useEffect, useMemo } from "react";
import ReactSelect from "react-select";
import { getActiveColorStyle } from "utils/colorUtils";
import { getSelectStyles } from "utils/selectStyles";

const Select = ({
  activeColor = "blue",
  options = [],
  value = null,
  onChange = () => { },
  placeholder = "Select...",
  isSearchable = true,
  isClearable = false,
  closeMenuOnSelect = true,
  className = "react-select",
  name = "",
  isDisabled = false,
  isLoading = false,
  styles: stylesProp,
  ...props
}) => {
  const [isLightTheme, setIsLightTheme] = useState(false);

  useEffect(() => {
    const checkTheme = () => {
      setIsLightTheme(document.body.classList.contains('white-content'));
    };
    checkTheme();

    const observer = new MutationObserver(checkTheme);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  const activeColorStyle = useMemo(() => getActiveColorStyle(activeColor), [activeColor]);
  const defaultSelectStyles = useMemo(() => getSelectStyles(activeColorStyle, isLightTheme), [activeColorStyle, isLightTheme]);
  const resolvedStyles = stylesProp ?? defaultSelectStyles;

  return (
    <ReactSelect
      styles={resolvedStyles}
      className={className}
      placeholder={placeholder}
      name={name}
      isSearchable={isSearchable}
      closeMenuOnSelect={closeMenuOnSelect}
      value={value}
      onChange={onChange}
      options={options}
      isClearable={isClearable}
      isDisabled={isDisabled}
      isLoading={isLoading}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      {...props}
    />
  );
};

export default Select;
